module.exports = __webpack_public_path__ + "img/vertical_3_5_0.d7b00ff0.png";